module.exports = __webpack_public_path__ + "static/media/ios-megaphone.8a24fce5.svg";